"use strict";
/**
 * Copilot Tool Type Definitions
 * Shared type definitions for copilot tools used across frontend and backend
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.TemplateToolIdValues = void 0;
/**
 * Template tool ID constants for runtime usage
 */
exports.TemplateToolIdValues = {
    SIMPLE_HAIKU_GENERATOR: 'simpleHaikuGenerator',
    SMART_URL_FETCH: 'smartUrlFetch',
    GOOGLE_ADS_CAMPAIGN_ANALYZER: 'googleAdsCampaignAnalyzer',
    GOOGLE_ADS_CAMPAIGN_ANALYSIS: 'googleAdsCampaignAnalysis',
    GOOGLE_ADS_AD_GROUP_KEYWORDS_UPDATE: 'googleAdsAdGroupKeywordsUpdate',
    UPDATE_GOOGLE_ADS_CAMPAIGN: 'updateGoogleAdsCampaign',
    FRAMER_WEB_PUBLISHER: 'framerWebPublisher',
    SHOPIFY_WEB_PUBLISHER: 'shopifyWebPublisher',
    WORDPRESS_WEB_PUBLISHER: 'wordpressWebPublisher',
    SEO_ARTICLE_WRITER: 'seoArticleWriter',
    SEO_ARTICLE_UPDATER: 'seoArticleUpdater',
    SOCIAL_MEDIA_RESEARCH: 'socialMediaResearch',
    POST_TWEET_TO_TWITTER: 'postTweetToTwitter',
    PUBLISH_LINKEDIN_POST: 'publishLinkedinPost',
    INSTAGRAM_AUDIO_FINDER: 'instagramAudioFinder',
    INSTAGRAM_INFLUENCER_DISCOVERY: 'instagramInfluencerDiscovery',
    INSTAGRAM_PROFILE_SCRAPER: 'instagramProfileScraper',
    INSTAGRAM_FOLLOWERS_SCRAPER: 'instagramFollowersScraper',
    INSTAGRAM_FOLLOWING_SCRAPER: 'instagramFollowingScraper',
    TOP_PERFORMING_VIDEO_FINDER_BY_TOPIC: 'topPerformingVideoFinderByTopic',
    YOUTUBE_TO_SOCIAL_MEDIA_PROMOTIONS: 'youtubeToSocialMediaPromotions',
    URL_TECHNICAL_SEO_AUDIT: 'urlTechnicalSeoAudit',
    URL_BACKLINKS_ANALYSIS: 'urlBacklinksAnalysis',
    AI_VISIBILITY: 'aiVisibility',
    CSV_READ_AND_FILTER: 'csvReadAndFilter',
    SEO_KEYWORDS: 'seoKeywords',
    SEO_BACKLINKS: 'seoBacklinks',
    SEO_DOMAIN_DATA: 'seoDomainData',
    SEO_TRAFFIC_ESTIMATE: 'seoTrafficEstimate',
    SEO_KEYWORD_OPPORTUNITY_FINDER: 'seoKeywordOpportunityFinder',
    SEO_TECH_AUDIT: 'seoTechAudit',
    GOOGLE_SEARCH_CONSOLE_URL_INSPECTOR: 'googleSearchConsoleUrlInspector',
    GOOGLE_SEARCH_CONSOLE_PERFORMANCE_METRICS: 'googleSearchConsolePerformanceMetrics',
    GOOGLE_SEARCH_CONSOLE_LIST_SITES: 'googleSearchConsoleListSites',
    FACEBOOK_ADS_CAMPAIGN_MANAGEMENT: 'facebookAdsCampaignManagement',
    FACEBOOK_ADS_AD_SET_MANAGEMENT: 'facebookAdsAdSetManagement',
    FACEBOOK_ADS_AD_MANAGEMENT: 'facebookAdsAdManagement',
    FACEBOOK_ADS_LEADGEN_FORM_MANAGEMENT: 'facebookAdsLeadgenFormManagement',
    FACEBOOK_ADS_LEADGEN_FORM_LIST: 'facebookAdsLeadgenFormList',
    FACEBOOK_ADS_SEARCH_TARGETING: 'facebookAdsSearchTargeting',
    FACEBOOK_ADS_PIXEL_LIST: 'facebookAdsPixelList',
    FACEBOOK_ADS_PIXEL_MANAGEMENT: 'facebookAdsPixelManagement',
    FACEBOOK_ADS_GET_CAMPAIGN_DETAILS: 'facebookAdsGetCampaignDetails',
    FACEBOOK_ADS_GET_ADSET_DETAILS: 'facebookAdsGetAdSetDetails',
    FACEBOOK_ADS_GET_AD_DETAILS: 'facebookAdsGetAdDetails',
    FACEBOOK_ADS_GET_CREATIVE: 'facebookAdsGetCreative',
    GOOGLE_ADS_CAMPAIGN_MANAGEMENT_TOOL: 'googleAdsCampaignManagementTool',
    GOOGLE_ADS_AD_GROUP_MANAGER: 'googleAdsAdGroupManager',
    GOOGLE_ADS_ASSET_GROUP_MANAGER: 'googleAdsAssetGroupManager',
    GOOGLE_ADS_KEYWORD_MANAGER: 'googleAdsKeywordManager',
    GOOGLE_ADS_AD_MANAGER_WITH_EXTENSIONS: 'googleAdsAdManagerWithExtensions',
    GOOGLE_ADS_NEGATIVE_KEYWORD_MANAGER: 'googleAdsNegativeKeywordManager',
    GOOGLE_ADS_KEYWORD_PERFORMANCE_TOOL: 'googleAdsKeywordPerformanceTool',
    GOOGLE_ADS_GET_KEYWORD_DETAILS: 'googleAdsGetKeywordDetails',
    GOOGLE_ADS_GET_CAMPAIGN_DETAILS: 'googleAdsGetCampaignDetails',
    GOOGLE_ADS_LIST_RESOURCES: 'googleAdsListCampaigns',
    GOOGLE_ADS_GET_AD_GROUP_DETAILS: 'googleAdsGetAdGroupDetails',
    GOOGLE_ADS_GET_AD_DETAILS: 'googleAdsGetAdDetails',
    GOOGLE_ADS_GET_SEARCH_QUERY_DETAILS: 'googleAdsGetSearchQueryDetails',
    GOOGLE_ADS_GET_ASSET_GROUP_DETAILS: 'googleAdsGetAssetGroupDetails',
    GOOGLE_ADS_GET_ASSET_DETAILS: 'googleAdsGetAssetDetails',
    GOOGLE_ADS_GET_PLACEMENT_DETAILS: 'googleAdsGetPlacementDetails',
    GOOGLE_ADS_GET_PRODUCT_GROUP_DETAILS: 'googleAdsGetProductGroupDetails',
    GOOGLE_ADS_GET_PRODUCT_DETAILS: 'googleAdsGetProductDetails',
    GOOGLE_ADS_GET_EXTENSION_DETAILS: 'googleAdsGetExtensionDetails',
    GOOGLE_ADS_FETCH: 'googleAdsFetch',
    GOOGLE_ADS_INSIGHTS: 'googleAdsInsights',
    META_ADS_FETCH: 'metaAdsFetch',
    FACEBOOK_ADS_INSIGHTS: 'facebookAdsInsights',
    CREATE_DOCUMENT: 'createDocument',
    CREATE_SLIDE_DECK: 'createSlideDeck',
    CREATE_IMAGE: 'createImage',
};
